import React from 'react';

type IconProps = React.SVGProps<SVGSVGElement>;
type Icon = (p: IconProps) => React.ReactElement<SVGSVGElement>;

const ReassignOwnerIcon: Icon = (props) => (
  <svg width="24px" viewBox="0 0 64 61.9" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M39.4,16.6l-4-4c-0.8-0.8-2-0.8-2.8,0c-0.8,0.8-0.8,2,0,2.8l0.6,0.6H26c-1.1,0-2,0.9-2,2v26h-2.3c-0.9-3.4-4-6-7.7-6c-4.4,0-8,3.6-8,8s3.6,8,8,8c3.7,0,6.8-2.6,7.7-6H28c1.1,0,2-0.9,2-2s-0.9-2-2-2V20h5.2l-0.6,0.6c-0.8,0.8-0.8,2,0,2.8C33,23.8,33.5,24,34,24s1-0.2,1.4-0.6l4-4C40.2,18.6,40.2,17.4,39.4,16.6z M14,50c-2.2,0-4-1.8-4-4s1.8-4,4-4s4,1.8,4,4S16.2,50,14,50z" />
    <path d="M50,26c4.4,0,8-3.6,8-8s-3.6-8-8-8s-8,3.6-8,8S45.6,26,50,26z M50,14c2.2,0,4,1.8,4,4s-1.8,4-4,4s-4-1.8-4-4S47.8,14,50,14z" />
    <path d="M50,38c-3.7,0-6.8,2.6-7.7,6H42c-1.1,0-2,0.9-2,2s0.9,2,2,2h0.3c0.9,3.4,4,6,7.7,6c4.4,0,8-3.6,8-8S54.4,38,50,38z M50,50c-2.2,0-4-1.8-4-4s1.8-4,4-4s4,1.8,4,4S52.2,50,50,50z" />
    <path d="M36,44h-2c-1.1,0-2,0.9-2,2s0.9,2,2,2h2c1.1,0,2-0.9,2-2S37.1,44,36,44z" />
  </svg>
);

export default ReassignOwnerIcon;
